<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex md12 sm12 lg12 xs12 v-if="$store.state.meteo">
        <Loading v-show="showLoading" />
        <template v-if="$store.state.meteo">
          <v-card id="meteo" class="card extra">
            <v-toolbar
              color="light-green lighten-2"
              dark
              style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; margin-bottom:-8px;"
              @click="forecastReadyDaily = !forecastReadyDaily"
            >
              <v-toolbar-title
                center
                style="color: white !important; text-align: center !important;"
                class="justify-center"
              >
                <h4 class="text-xs-center">
                  <v-icon class="icon">mdi-finance</v-icon>WEATHER STATION
                </h4>
              </v-toolbar-title>
            </v-toolbar>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6 lg6> </v-flex>
              <v-flex xs6 sm6 md3 lg3>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="date"
                  lazy
                  dark
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      prepend-icon="mdi-calendar-today"
                      v-model="date"
                      label="From"
                      readonly
                      flat
                      v-on="on"
                    />
                  </template>
                  <v-date-picker v-model="date" locale="en" range scrollable>
                    <v-btn flat color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn flat color="primary" @click="onClick()">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 sm6 md3 lg3>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="-100"
                  :return-value.sync="date2"
                  lazy
                  dark
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      prepend-icon="mdi-calendar"
                      v-model="date2"
                      label="To"
                      readonly
                      flat
                      v-on="on"
                    />
                  </template>
                  <v-date-picker v-model="date2" locale="en" range>
                    <v-spacer />
                    <v-btn flat color="primary" @click="menu2 = false"
                      >Cancel</v-btn
                    >
                    <v-btn flat color="primary" @click="onClick2()">OK</v-btn>
                  </v-date-picker>
                </v-menu>
                <v-spacer />
              </v-flex>
            </v-layout>
            <v-btn
              right
              round
              class="historic"
              color="#9ccc65"
              @click="update()"
            >
              Update
              <v-icon class="icon">mdi-update</v-icon>
            </v-btn>

            <div id="metoChart" style="width:100%; height:300px;" />
            <br />
          </v-card>
        </template>

        <br />

        <v-card v-if="$store.state.meteo" id="alert-daily" class="card meteo">
          <v-toolbar
            color="light-green lighten-2"
            dark
            style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; cursor: pointer;"
            @click="forecast = !forecast"
          >
            <v-toolbar-title
              center
              style="color: white !important; text-align: center !important; "
              class="justify-center"
            >
              <h4 class="text-xs-center">
                <v-icon class="icon">mdi-white-balance-sunny</v-icon>TODAY
              </h4>
            </v-toolbar-title>
          </v-toolbar>
          <!-- <br /> -->
          <template v-if="forecast">
            <div class="content">
              <v-layout row wrap>
                <v-flex xs12 sm12 md4 lg4>
                  <h5 class="meteoInfo text-xs-left">
                    Amb Temp:
                    <h5 class="value">
                      {{
                        $store.state.meteo.specificTypeParameters
                          .ambientTemperature *
                          1.8 +
                          32
                      }}ºF
                    </h5>
                  </h5>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4>
                  <h5 class="meteoInfo text-xs-left">
                    Rel. Humidity:
                    <h5 class="value">
                      {{
                        $store.state.meteo.specificTypeParameters.relativeHumidity.toFixed(
                          2
                        )
                      }}%
                    </h5>
                  </h5>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4>
                  <h5 class="meteoInfo text-xs-left">
                    Today's Acc Solar Rad:
                    <h5 class="value">
                      {{
                        (
                          $store.state.meteo.specificTypeParameters
                            .solarRadiationAcc / 10000
                        ).toFixed(2)
                      }}
                      Joules
                    </h5>
                  </h5>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <!-- <v-flex xs12 sm12 md4 lg4>
                  <h5 class="meteoInfo text-xs-left">
                    Radiation Solar:
                    <h5 class="value">
                      {{
                        $store.state.meteo.specificTypeParameters.solarRadiation.toFixed(
                          2
                        )
                      }}
                      W/m
                      <sup>2</sup>
                    </h5>
                  </h5>
                </v-flex> -->
                <!-- <v-flex xs12 sm12 md4 lg4>
                  <h5 class="meteoInfo text-xs-left">
                    Today's Precipitation:
                    <h5 class="value">
                      {{
                        (
                          (($store.state.meteo.specificTypeParameters
                            .rainGaugeCount -
                            $store.state.meteo.specificTypeParameters
                              .raindropsCut) *
                            2) /
                          20
                        ).toFixed(2)
                      }}
                      in
                    </h5>
                  </h5>
                </v-flex> -->
                <!-- <v-flex xs12 sm12 md4 lg4>
                  <h5 class="meteoInfo text-xs-left">
                    Yesterday's Precipitation:
                    <h5 class="value">
                      {{ pastRainGaugeCount }}
                      in
                    </h5>
                  </h5>
                </v-flex> -->
              </v-layout>

              <!-- <v-layout row wrap>
              <v-flex xs12 sm12 md6 lg6>
                <h5 class="meteoInfo text-xs-left">
                  Rad. Solar Ac. Hoy:
                  <h5 class="value">
                    {{
                    (
                    $store.state.meteo.specificTypeParameters
                    .solarRadiationAcc / 10000
                    ).toFixed(2)
                    }}
                    J/cm
                    <sup>2</sup>
                  </h5>
                </h5>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <h5 class="meteoInfo text-xs-left">
                  Precip. del día anterior:
                  <h5 class="value">
                    {{ pastRainGaugeCount }}
                    in
                  </h5>
                </h5>
              </v-flex>
              </v-layout>-->

              <!-- <v-layout row wrap>
                <v-flex xs12 sm12 md4 lg4>
                  <h5 class="meteoInfo text-xs-left">
                    Rad. Solar Ac. del día anterior:
                    <h5 class="value">
                      {{ Math.round(pastRadAcc) }}
                      J/cm
                      <sup>2</sup>
                    </h5>
                  </h5>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4></v-flex>
                <v-flex xs12 sm12 md4 lg4></v-flex>
              </v-layout>-->
              <!-- <br /> -->
            </div>
          </template>
        </v-card>
      </v-flex>

      <v-layout row wrap>
        <v-flex md12 sm12 lg12 xs12>
          <Map v-if="$store.state.subProject" style="height: 300px;" />
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
const Loading = () => import("../components/resources/Loading.vue");

import Map from "../components/resources/Forecast";
import moment from "moment-timezone";
// const DATE_FORMAT = "M/D, h:inA";
const DATE_FORMAT = "M/D, h:mmA";
import axiosApi from "../axios-api";

export default {
  components: {
    Map,
    Loading,
  },
  data() {
    return {
      showLoading: true,
      select: null,
      date: null,
      date2: null,
      menu: false,
      menu2: false,
      ready: false,
      pastRadAcc: null,
      pastRainGaugeCount: null,
      forecast: false,
    };
  },

  async beforeMount() {
    if (this.$store.state.meteo == null) {
      // this.showLoading = false;
    } else {
      let id = this.$store.state.meteo.sigfoxId;
      // console.log(id);

      this.select = id;

      let date = new Date(new Date().setHours(0, 0, 0, 0));
      let date2 = new Date(new Date().setHours(24, 0, 0, 0));

      this.date = new Date(date.setDate(date.getDate() - 5))
        .toISOString()
        // .toLocaleString()
        .substr(0, 10);
      this.date2 = new Date(date2.setDate(date2.getDate() + 1))
        .toISOString()
        // .toLocaleString()
        .substr(0, 10);

      let params = {
        sigfoxDeviceId: id,
        startDate: new Date(date.setDate(date.getDate() - 2)),
        endDate: new Date(date2.setDate(date2.getDate())),
      };
      console.log("params", params);

      await axiosApi
        .get(`/message/get-by-device`, {
          params,
        })
        .then((data) => {
          let res = data.data;

          res.sort(function(a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.date) - new Date(a.date);
          });

          res.reverse();

          // console.log("res meteo", res);
          if (res[170]) {
            this.pastRadAcc = res[170].solarRadiationAcc / 10000;
          } else {
            this.pastRadAcc = 0;
          }

          if (res[180]) {
            this.pastRainGaugeCount =
              ((res[180].rainGaugeCount - res[180].raindropsCut) * 2) / 20;
          } else {
            this.pastRainGaugeCount = 0;
          }
        });
      this.update();
    }

    this.$store.dispatch("getProjectsArr", this.$store.state.companyId);
  },
  methods: {
    onClick() {
      this.$refs.menu.save(this.date);
      // console.log("CHUY", new Date(this.date).toISOString());
    },
    onClick2() {
      this.$refs.menu2.save(this.date2);
      this.ready = true;
      // console.log("CHUY2", this.date2);
      // this.click2();
    },
    async update() {
      if (this.$store.state.userId == 22) {
        this.showLoading = false;
        let params = {
          sigfoxDeviceId: "45BD05",
          startDate: new Date(this.date).toISOString().toLocaleString(),
          // endDate: new Date(this.date2).toISOString().toLocaleString(),
          endDate: new Date(new Date(this.date2).setHours(23))
            .toISOString()
            .toLocaleString(),
        };
        // console.log(params);

        await axiosApi
          .get(`/message/get-by-device`, {
            params,
          })
          .then((data) => {
            let res = data.data;
            res.sort(function(a, b) {
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.date) - new Date(a.date);
            });

            res.reverse();
            console.log("Data", res);
            // console.log("TEST", res);
            // let date = res.map((x) => new Date(x.date));

            let solarRadiation = res.map((x) => {
              if (x.solarRadiation == undefined) {
                return (x.solarRadiation = 0);
              }
              return Math.round(x.solarRadiation);
            });
            let solarRadiationAcc = res.map((x) => {
              if (x.solarRadiationAcc == undefined) {
                return (x.solarRadiationAcc = 0);
              }
              return Math.round(x.solarRadiationAcc / 10000);
            });
            let ambientTemperature = res.map((x) => {
              if (x.ambientTemperature == undefined) {
                return (x.ambientTemperature = 0);
              }
              // return x.ambientTemperature;
              return x.ambientTemperature * 1.8 + 32;
            });
            // console.log("solar rad", solarRadiationAcc);
            let rainGaugeAcc = res.map((x) => {
              if (x.rainGaugeCount == undefined) {
                return (x.rainGaugeCount = 0);
              }
              // return ((x.rainGaugeCount - x.previousRainGauge) * 2) / 20;
              return ((x.rainGaugeCount - x.previousRainGauge) * 2) / 20 / 25.4;
            });

            let rainAcc = res.map((x) => {
              if (x.rainGaugeCount == undefined) {
                return (x.rainGaugeCount = 0);
              }
              // return ((x.rainGaugeCount - x.raindropsCut) * 2) / 20;
              return ((x.rainGaugeCount - x.raindropsCut) * 2) / 20 / 25.4;
            });

            let relativeHumidity = res.map((x) => {
              return x.relativeHumidity;
            });

            // console.log("Humidity", relativeHumidity);
            // console.log(date);
            // console.log(solarRadiation);
            // console.log(rainGaugeAcc);
            // this.modal = true;
            this.populateChartMeteo(
              // date,
              solarRadiation,
              solarRadiationAcc,
              rainGaugeAcc,
              rainAcc,
              ambientTemperature,
              relativeHumidity,
              res
            );
          });
      } else {
        let params = {
          sigfoxDeviceId: this.select,
          startDate: new Date(this.date).toISOString().toLocaleString(),
          // endDate: new Date(this.date2).toISOString().toLocaleString(),
          endDate: new Date(new Date(this.date2).setHours(23))
            .toISOString()
            .toLocaleString(),
        };
        // console.log(params);

        await axiosApi
          .get(`/message/get-by-device`, {
            params,
          })
          .then((data) => {
            let res = data.data;
            res.sort(function(a, b) {
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.date) - new Date(a.date);
            });

            res.reverse();
            // console.log("TEST", res);
            // let date = res.map((x) => new Date(x.date));
            let solarRadiation = res.map((x) => {
              if (x.solarRadiation == undefined) {
                return (x.solarRadiation = 0);
              }
              return Math.round(x.solarRadiation);
            });
            let solarRadiationAcc = res.map((x) => {
              if (x.solarRadiationAcc == undefined) {
                return (x.solarRadiationAcc = 0);
              }
              return Math.round(x.solarRadiationAcc / 10000);
            });
            let ambientTemperature = res.map((x) => {
              if (x.ambientTemperature == undefined) {
                return (x.ambientTemperature = 0);
              }
              // return x.ambientTemperature;
              return x.ambientTemperature * 1.8 + 32;
            });
            // console.log("solar rad", solarRadiationAcc);
            let rainGaugeAcc = res.map((x) => {
              if (x.rainGaugeCount == undefined) {
                return (x.rainGaugeCount = 0);
              }
              // return ((x.rainGaugeCount - x.previousRainGauge) * 2) / 20;
              return ((x.rainGaugeCount - x.previousRainGauge) * 2) / 20 / 25.4;
            });

            let rainAcc = res.map((x) => {
              if (x.rainGaugeCount == undefined) {
                return (x.rainGaugeCount = 0);
              }
              // return ((x.rainGaugeCount - x.raindropsCut) * 2) / 20;
              return ((x.rainGaugeCount - x.raindropsCut) * 2) / 20 / 25.4;
            });

            let relativeHumidity = res.map((x) => {
              return x.relativeHumidity / 1.1;
            });

            // console.log("Humidity", relativeHumidity);
            // console.log(date);
            // console.log(solarRadiation);
            // console.log(rainGaugeAcc);
            // this.modal = true;
            this.populateChartMeteo(
              // date,
              solarRadiation,
              solarRadiationAcc,
              rainGaugeAcc,
              rainAcc,
              ambientTemperature,
              relativeHumidity,
              res
            );
          });

        // this.showLoading = false;
      }
    },
    populateChartMeteo(
      // date,
      radiation,
      solarRadiationAcc,
      pulses,
      rainAcc,
      ambientTemperature,
      relativeHumidity,
      res
    ) {
      // console.log("chuahusdhsai", res);
      const categories = res.map((x) => {
        const formatted = moment(x.date.toLocaleString()).format(DATE_FORMAT);
        // console.log("before: ", x.date);
        // console.log("after: ", formatted);
        return formatted;
      });

      this.$Highcharts.chart("metoChart", {
        chart: {
          zoomType: "xy",
        },
        legend: {
          width: 1000,
          verticalAlign: "top",
          x: 50,
          y: 6,
          floating: true,
        },
        tooltip: {
          shared: true,
          valueDecimals: 2,
        },
        title: {
          text: "Weather Station",
          // text: "",
          y: 5,
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories,
          crosshair: true,
          tickInterval: 80,
        },
        yAxis: [
          {
            max: 80,
            labels: {
              format: "{value} %",
              style: {
                color: "#81D4FA",
              },
            },
            title: {
              // text: "Rel. Humidity",
              text: "",
              style: {
                color: "#81D4FA",
              },
            },
            // opposite: true,
          },
          {
            labels: {
              format: "{value} °F",
              style: {
                color: "#FF9800",
              },
            },
            title: {
              // text: "Ambient Temp.",
              text: "",
              style: {
                color: "#FF9800",
              },
            },
            opposite: true,
          },
          {
            labels: {
              format: "{value} W/m2",
              style: {
                color: "#F4511E",
              },
            },
            title: {
              // text: "W/m2",
              text: "",
              style: {
                color: "#F4511E",
              },
            },
          },

          {
            labels: {
              format: "{value} Joules",
              style: {
                color: "#EC407A",
              },
            },
            title: {
              // text: " Joules",
              text: "",
              style: {
                color: "#EC407A",
              },
            },
            plotLines: [
              {
                dashStyle: "Dash",
                color: "#FF0000",
                width: 1,
                value: 100,
                label: {
                  text: "100 Joules",
                  align: "right",
                  style: {
                    yAxis: 10,
                    zIndex: 10,
                    fontSize: "16px",
                  },
                },
              },
            ],
            opposite: false,
          },

          {
            max: 3,
            labels: {
              format: "{value} in",
              style: {
                color: "#01579B",
              },
            },
            title: {
              // text: "Acc Precipitation",
              text: "",
              style: {
                color: "#01579B",
              },
            },
            opposite: true,
          },
          {
            max: 3,
            labels: {
              format: "{value} in",
              style: {
                color: this.$Highcharts.getOptions().colors[0],
              },
            },
            title: {
              // text: "Precipitation",
              text: "",
              style: {
                color: this.$Highcharts.getOptions().colors[0],
              },
            },
            opposite: true,
          },
        ],
        series: [
          {
            type: "areaspline",
            data: relativeHumidity,
            name: "Rel. Humidity",
            color: "#81D4FA",
            yAxis: 0,
            tooltip: {
              valueSuffix: "%",
            },
          },
          {
            type: "areaspline",
            data: ambientTemperature,
            name: "Ambient Temp.",
            color: "#FF9800",
            yAxis: 1,
            tooltip: {
              valueSuffix: "°F",
            },
          },
          {
            type: "areaspline",
            width: 1,
            data: solarRadiationAcc,
            yAxis: 3,
            name: "Acc Radiation",
            color: "#EC407A",
            tooltip: {
              valueSuffix: " Joules",
            },
          },
          {
            type: "areaspline",
            data: radiation,
            name: "Radiation",
            color: "#F4511E",
            yAxis: 2,
            tooltip: {
              valueSuffix: " W/m2",
            },
          },

          {
            type: "areaspline",
            data: rainAcc,
            name: "Acc Precipitation",
            color: "#01579B",
            yAxis: 4,
            tooltip: {
              valueSuffix: "in",
            },
          },
          {
            type: "areaspline",
            data: pulses,
            name: "Precipitation",
            yAxis: 5,
            tooltip: {
              valueSuffix: "in",
            },
          },
        ],
      });
      this.showLoading = false;
    },
  },
};
</script>

<style scoped>
.container {
  height: 100% !important;
}

.vector {
  margin-left: 60%;
  margin-top: 35%;
  width: 70%;
  opacity: 0.5;
}

.icon {
  margin-right: 10px;
}

.content {
  margin-top: 40px;
  position: relative;
  display: block !important;
}

.meteoInfo {
  color: gray;
  margin-top: -20px !important;
  margin-left: 33% !important;
}

.historic {
  height: 35px !important;
  width: 95% !important;
  margin-left: 4% !important;
  margin-top: -5px !important;
  margin-bottom: 20px !important;
}

.value {
  margin-top: -5px !important;
  font-weight: bold !important;
  color: black;
}

@media only screen and (max-width: 600px) {
  .meteoInfo {
    margin-left: 20% !important;
  }

  .historic {
    margin-left: 8% !important;
  }
}
</style>
